import PropTypes from 'prop-types';
import TreeItem from '../Components/TreeNavigator/TreeItem';

const TreeNavigatorMultipleItemPropTypes = {
  treeItem: PropTypes.instanceOf(TreeItem).isRequired,
};
export default TreeNavigatorMultipleItemPropTypes;
